import { render } from "./login.vue?vue&type=template&id=b4afd954&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=b4afd954&lang=scss"
import "./login.vue?vue&type=style&index=1&id=b4afd954&scoped=true&lang=scss"
import "./login.vue?vue&type=style&index=2&id=b4afd954&lang=css"

import exportComponent from "/codebuild/output/src3843889989/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4afd954"]])

export default __exports__